module.exports = __webpack_public_path__ + "img/027b71f1a2a778e5e67cd33859a4f153.svg";